export default "__VITE_ASSET__07a920d4__"